import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';

export function DialogTitle({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={twMerge(
        'font-medium1-bold whitespace-pre-wrap break-all text-center text-theme-solid-100',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export const DialogTitleType = (<DialogTitle />).type;
